export default {
  svgPath: `
    <path d="M7.15657 12.5566C6.76604 12.9471 6.13288 12.9471 5.74235 12.5566L0.0856746 6.89988L1.49989 5.48567L6.44946 10.4352L16.349 0.535749L17.7632 1.94996L7.15657 12.5566Z" fill="currentColor" />
  `,
  title: 'Check',
};

